import {IBizPromotion, IBusiness} from "@/views/editor/service/business";
import {Component, defineComponent, h} from "vue";
import {ScheduleOutlined} from "@ant-design/icons-vue";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";
import {AEditor} from "@/views/editor/service/editor";
import {IActivityBusinessMeta} from "@/model/activity";
import {APromotion} from "@/views/editor/service/promotion/promotion";

export default class Deposit extends APromotion implements IBizPromotion {
    readonly icon = () => h(ScheduleOutlined, {style: 'color:#22c55e'});
    readonly title = '预售';
    readonly description = '通过前置锁定用户预算与心智，将不确定的市场博弈转化为高确定性的流量抢占与供需匹配。';

    constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }

    subs(): CheckboxOptionType[] {
        return []
    }

    resetMeta(): IBusiness {
        return this;
    }

    price(): number {
        return 0
    }

    lookersListView(): { title: string, component: Component } {
        return {title: '', component: defineComponent({})}
    }
}